// This file was automatically generated from appchart.dialog.ordermed.txStartDate.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.txStartDate');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.txStartDate.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><form id="med-thread-start-date-form"><div class="el8FieldSection"><label class="el8label el8FieldMedium">Medication:</label><div class="el8FieldMediumLabelPadding el8Wrap"><p id="med-thread-start-date-med-info"></p></div></div><div class="el8FieldSection"><label class="el8label el8FieldMedium">Start Date:</label><div class="el8FieldMediumLabelPadding el8TextareaWrap el8DatePickerWrap"><input type="text"  class="el8DatePicker" name="startDate" /></div></div></form></div>');
  if (!opt_sb) return output.toString();
};
